import { IResultData } from "@/domain/entities/shared/result";
import { IUserInfo } from "@/domain/entities/user";
import { useUserStore } from "@/stores/userStore";
import { ErrorTypeCode } from "@/types";
import useGetAccessToken from "@/use/useGetAccessToken";

/**
 * 유저 정보를 조회한 결과를 반환한다.
 * 이 과정에서 userStore에 userInfo가 갱신된다.
 */
export async function useGetUserInfo(): Promise<IResultData<IUserInfo>> {
  const userStore = useUserStore();
  const accessToken = useGetAccessToken();
  if (!accessToken) {
    return {
      isSuccess: false,
      errorMessage: "Access Token이 존재하지 않습니다.",
      errorType: ErrorTypeCode.NOT_FOUND_ACCESS_TOKEN,
    } as IResultData<IUserInfo>;
  }

  return await userStore.getUserInfo();
}
